import { Box } from "@mui/material";

export const PageContainer = ({ pageHeader, children, borderTop, borderRight }) => {
  return (
    <Box
      sx={(theme) => ({
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#EDF0F4",
        borderTop: borderTop ? `1px solid ${theme.palette.action.disabled}` : "none",
        borderRight: borderRight ? `1px solid ${theme.palette.action.disabled}` : "none",
      })}
    >
      {pageHeader}
      <Box
        sx={{
          flexGrow: 1,
          overflow: "hidden",
          p: "10px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
